import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import AuthNavbar from "./AuthNavbar";
import AuthFooter from "../components/footer/SiteFooter";
import apiConfig from "./AxiosConfig";
const Auth = () => {
  useEffect(() => {
    apiConfig(() => {});
  }, []);
  return (
    <React.Fragment>
      <Outlet />
      <AuthFooter />
    </React.Fragment>
  );
};
export default Auth;
